// import { useTranslation } from "react-i18next";

// function Translate() {
//   const { i18n } = useTranslation();

//   return (
//     <div style={{ textAlign: "right", padding: "10px" }}>
//       <button onClick={() => i18n.changeLanguage("en")}>
//         English
//       </button>

//       <button onClick={() => i18n.changeLanguage("ta")}>
//         தமிழ்
//       </button>
//     </div>
//   );
// }

// export default Translate;


import { useEffect } from "react";
import "./googletranslate.css";

const Translate = () => {

  // useEffect(() => {
  //   if (!window.google) {
  //     const script = document.createElement("script");
  //     script.src =
  //       "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  //     script.async = true;
  //     document.body.appendChild(script);
  //   }
  // }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);
    //     document.body.appendChild(script);

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "en,ta",
          autoDisplay: false
        },
        "google_translate_element"
      );
    };



    // Remove google banner repeatedly
    const interval = setInterval(() => {
      const banner = document.querySelector(".goog-te-banner-frame");
      if (banner) {
        banner.style.display = "none";
      }
      document.body.style.top = "0px";
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return <div id="google_translate_element" style={{ display: "none" }}></div>;
};

export default Translate;